/**
 * OutStreamController
 * @type {(string|(function(*, *))|*)[]}
 */
const OutStreamController =  ['$scope', '$lazyScripts', function($scope, $lazyScripts) {

    $scope.outStream = {
        client: null,
        tracker: null,
        progress: 0,
        skipRemain: 5,
        skipDelay: 5,
        skipShow: false,
        media: {},
        available: false,
        started: false,
        finished: false,
        play() {
            if (  $scope.outStream.available && !($scope.outStream.started || $scope.outStream.finished)) {
                $scope.outStream.started = true;
                this.tracker.trackImpression();
                this.tracker.track('start');
            }
        },
        skip() {
            $scope.outStream.available = false;
            this.tracker.track('skip');
        },
        click() {
            this.tracker.click();
        },
        load() {
            this.client = new VAST.VASTClient();
            this.client.get($scope.service.outStream.vast).then(res => {
                if (res.hasOwnProperty('ads') === false || res.ads.length === 0) {
                    return false;
                }
                this.tracker = new VAST.VASTTracker(this.client, res.ads[0], res.ads[0].creatives[0]);
                this.tracker.load();

                this.available = true;
                this.media = res.ads[0].creatives[0].mediaFiles[0];
                this.clickthrough = res.ads[0].creatives[0].videoClickThroughURLTemplate.url;

                $scope.$apply();
            });
        },
    };

    $scope.$watch('service.ready', (ready) => {
        if ( ready === true && $scope.service.outStream.visible ) {
            $lazyScripts.loadVast().then(() => {
                $scope.outStream.load();
            });
        }
    });

}];

export default OutStreamController;
